<script setup lang="ts">
defineProps({
	selected: { type: Boolean, default: false },
	label: { type: String, required: true },
	disabled: { type: Boolean, default: false },
});
</script>

<template>
	<button type="button" class="chip-button" :class="{ 'chip-button--selected': selected, 'chip-button--disabled': disabled }" :disabled="disabled">
		{{ label }}
	</button>
</template>

<style lang="scss" scoped>
.chip-button {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	height: 36px;
	padding: 0 16px;
	border: 1px solid rgba(255, 255, 255, 0.15);
	border-radius: 8px;
	background: rgba(255, 255, 255, 0.05);
	color: rgba(255, 255, 255, 0.6);
	font-family: 'SourceSansPro-SemiBold', sans-serif;
	font-size: 14px;
	line-height: 1;
	cursor: pointer;
	white-space: nowrap;
	user-select: none;
	transition: all 0.2s ease;
	box-shadow: none;

	&:hover:not(:disabled) {
		border-color: rgba(255, 255, 255, 0.25);
	}
}

.chip-button--selected {
	background: var(--ion-color-primary);
	border-color: var(--ion-color-primary);
	color: var(--clientx-color-button-text);
	box-shadow: 0 0 12px rgba(var(--ion-color-primary-rgb), 0.35);

	&:hover:not(:disabled) {
		opacity: 0.85;
	}
}

.chip-button--disabled {
	opacity: 0.4;
	cursor: not-allowed;
}
</style>
